import { Tab, Box, Chip } from "@mui/material";

const TabWithCounter = ({ label, count, selected, ...props }) => {
  return (
    <Tab
      {...props}
      label={
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              mr: 1,
              color: selected ? "primary.main" : "text.secondary",
            }}
          >
            {label}
          </Box>
          <Chip
            label={count}
            size="small"
            color={selected ? "primary" : "default"}
          />
        </Box>
      }
    />
  );
};

export default TabWithCounter;